import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import {useState, useEffect} from 'react';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function TearmOfUse({meta}) {
	const [loading, setLoading] = useState(false); 
	const router = useRouter();

	return (
		<>
		 <Head>
				<meta name="keywords" content={meta ? meta.keywords : ''} />
				<title>{meta ? meta.title : ''}</title>
				<meta name="description" content={meta ? meta.description : ''} />
				<link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
			</Head>
	  		<div className="banner_breadcrumb_section" id="term_of_use">
					<div id="spinner" className="spinner_req_review" style={{ "display": loading ? "block" : "none" }}>
						<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
					</div>
					<Container fluid="xl">
						<h1 className="main-heading-lg">Terms of Use</h1>
					</Container>
				</div>
				<Container fluid="xl">
					<div className="about_sec1-intro  terms-section-set padding-set" >
						<div className="main-top">
							<p className="text-center">Our talent marketplace operates by certain rules that we call our terms of use. They apply to our websites, apps, and other products. These terms explain how we expect you to interact on our platforms whether you are a registered user or a site owner.
							</p><p className="text-center">
							Please read these rules carefully. When you use our site, you agree to follow them. </p>
						</div>

						<div className="content-wrap-set">
							<h4>
								1. Licenses and Third Party Content
							</h4>
							<p className="description-text">
								This section covers the conditions for using our site. We retain the rights to determine who uses our site and to our intellectual property. You however own copyrights to content that you produce or share through our platform.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.1. Limited license to use our site and services
							</h4>
							<p>
								We offer you a limited license to use our website, apps, products and services (which are known together as services). You can retain this license as long as you follow these terms of use and our terms of service as they apply to you. We will ensure that our services remain safe and accessible but we cannot guarantee unlimited access and fluctuations could occur from time to time due to maintenance, upgrade or other purposes. If we have to stop providing certain features or suspend the services, we can do this without providing notice to you.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.2. Suspension of your limited access
							</h4>
							<p className="description-text">
								We can stop you from accessing Toprow if you are in violation of this Terms of Use or other parts of our Terms of Service. We will let you know if this happens and you have to stop using our services as soon as your license is terminated.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.3. Intellectual Property Rights
							</h4>
							<p className="description-text">
								We hold trademarks on our logos, names and inscriptions. These marks are registered in certain jurisdictions and you cannot use them without our express permission. Work created by users or partners may also be trademarked. These include logos, symbols, names and similar marks.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.4. Your Intellectual Property
							</h4>
							<p className="description-text">
								You are responsible for data you share through or on our website. We cannot be held liable for content that you create. You can only share content or other data with us that does not violate anyone&#39;s rights including their intellectual property, is legal, and you have all the rights attached. You are responsible and answerable for any damages caused by content that you post on or through our platform and that you share with us.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.4.2. Accidental Rights to Your Content
							</h4>
							<p className="description-text">
							When you post on our site, you give us, our affiliates and partners an irrevocable and non-exclusive worldwide license to use, edit and share that content. We can use this content across the world without paying you royalties. We can use your name, voice, image if they appear in such content including using these in our marketing campaigns or in furthering our business such as sharing vendors&#39; profiles with businesses that may be a good match. </p>
							<p className="description-text">
							Every user or site visitor on our platform can also access or use your content on our website. They can copy and share this content as long as they follow our Terms of Service and the applicable laws.   </p>
							<p className="description-text">
							We can use your content including your name, photo and profile in marketing campaigns and advertising without compensating you.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.5. Third Parties&#39; Rights to Their Content
							</h4>
							<p className="description-text">
								Anyone who uses Toprow is responsible for what they post. We are not responsible for content posted on our platforms by others and cannot be held liable for the accuracy or reliability of such content. All content represents the views of the person posting them, not Toprow&#39;s views.
							</p>
							<p className="description-text">
								You may find links to third party websites and applications on our websites. We do not endorse and are not liable for content found on these links as these websites and applications are owned and run by other people. You agree that you do not have our endorsement when you use them.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								1.6. Copyright Claims
							</h4>
							<p className="description-text">
								We are bound by the copyright laws and you agree to follow them when you use our site either as a registered user or as a site visitor. You cannot post copyrighted content or otherwise store things that infringe other people&#39;s copyright on our website.
							</p>
							<p className="description-text">
								If you feel your copyright has been infringed, you can make copyright claims and ask us to remove such content.
							</p>
						</div>

						<div className="content-wrap-set">
							<h4>
								2. What You Can Do On Toprow
							</h4>
							<p className="description-text">
								You can find vendors and businesses to work with on Toprow. You can also find resources to help you build business relationships or other information relating to getting your projects completed and getting leads on Toprow. Such information would usually be available on the Toprow blog. We will keep such information as accurate as possible but cannot guarantee that they would be flawless. Information posted on Toprow is not intended as advice of any kind whether tax advice, legal advice, or other form of advice. When you access such information, you agree that you are responsible for verifying it before use.
							</p>
						</div>
						<div className="content-wrap-set">
							<h4>
								3. What You Can&#39;t Do On Toprow
							</h4>
							<p className="description-text">
								There are some things you cannot do on Toprow. Using our site or services in certain ways is not allowed. These include:
							</p>
							<ul>
								<li>
									Acting fraudulently or in a misleading manner
								</li>
								<li>
									Posting inappropriate content
								</li>
								<li>
									Abusing our system
								</li>
								<li>
									Unfair or unjust treatment of others
								</li>
							</ul>
							<p className="description-text">
								If what you want to do is fraudulent, harmful or illegal, you are not allowed to use Toprow for it. If such action is not included in this Terms of Use, you are still not allowed to do it.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								3.1. Fraudulent or Misleading Actions
							</h4>
							<p className="description-text">
								You are not allowed to misrepresent who you are, your skills, experience or professional qualifications. Actions like lying about these or impersonating others are a violation of this Terms of Use. You should not falsify your identity or advertise services that you are incapable of completing. Creating a false profile on Toprow is a big no-no and businesses should hire for tasks that they really need help with. Businesses must desist from hiring vendors with no intention to pay for tasks completed. Vendors&#39; compensations should be paid promptly once tasks are completed.
							</p>

						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								3.2. Posting Inappropriate Content
							</h4>
							<p className="description-text">
								You cannot share content that is defamatory, illegal, violent, sexually explicit, exploitative or infringing on anyone&#39;s rights of intellectual property on Toprow.
							</p>

						</div>
						<div className="content-wrap-set in-wrap">
							<h4>
								3.3. Abusing Our System
							</h4>
							<p className="description-text">
								You cannot offer, receive or purchase fake reviews on Toprow. Any attempt to mislead businesses or vendors violates this Terms of Use. You cannot coerce others into leaving a positive review. Threatening to leave negative feedback violates this Terms of Use. Do not use Toprow for activities that are unrelated to work done on the platform.
								</p>
								<p className="description-text">
								When you work on Toprow, you agree not to promote other organizations or connect with vendors or businesses and complete tasks off our platform. You also agree not to give your account away and misrepresent your identity as a result.
							</p>
						</div>

						<div className="content-wrap-set in-wrap">
							<h4>
								3.4. Unfair or Unjust Treatment of Others
							</h4>
							<p className="description-text">
								Do not use Toprow to discriminate against others on any basis. Spamming is unallowed on our platform. You cannot post or share sensitive or private information about others.
							</p>
						</div>

						<div className="content-wrap-set">
							<h4>
								4. Enforcement
							</h4>
							<p className="description-text">
								We will examine every violation of these Terms and take appropriate action in accordance with the governing law. If you believe a vendor or business is in violation of these Terms, you should let us know.
							</p>
						</div>

						<div className="content-wrap-set">
							<h4>
								5. Definitions
							</h4>
							<p className="description-text">
								Vendor - a person or agency who offers their services on Toprow. </p>
								<p className="description-text">
								Content - what users post on Toprow including their profiles, reviews, images and any other information. </p>
								<p className="description-text">
								Business - organizations using Toprow  to get professionals who would complete their tasks. 
							</p>
						</div>
					</div>
				</Container>
		</>	
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/term-of-use', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

TearmOfUse.Layout = PublicLayout;

export default TearmOfUse
